import { Checkbox, FormControlLabel } from '@material-ui/core'
import { ReactNode } from 'react'

interface Props {
  name: string
  value: boolean
  setValue: (val: boolean) => void
  label: ReactNode | string
  extraClasses?: string
  error?: string
  disabled?: boolean
}

const CheckboxInput = ({
  name,
  value,
  setValue,
  error,
  label,
  extraClasses,
  disabled,
  ...restProps
}: Props) => {
  return (
    <FormControlLabel
      className={`checkbox fs14 m-r-0 ${error ? 'error' : ''} ${extraClasses}`}
      control={
        <Checkbox
          name={name}
          color="primary"
          checked={value}
          onChange={(e) => setValue(e.target.checked)}
        />
      }
      label={label}
      {...restProps}
    />
  )
}

export default CheckboxInput
